module.exports = __webpack_public_path__ + "img/dragon_tiger.d06f4e6.jpg";